import {
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormSwitch,
  CInputGroup,
  CInputGroupText,
  CLoadingButton,
} from '@coreui/react-pro'
import React from 'react'
import Bootbox from 'bootbox-react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import PlayerService from 'src/service/PlayerService'
import { useEffect } from 'react'
import GeneralService from 'src/service/GeneralService'

const PlayerStructure = (props) => {
  const [showPosBased, setShowPosBased] = useState(false)
  const [showPosConfirm, setShowPosConfirm] = useState(false)
  const [modalText, setModalText] = useState('')
  const [labelText, setLabelText] = useState('')

  const handlePosConfirm = () => {
    savePosFree()
    return setShowPosConfirm(false)
  }
  const handlePosCancel = () => {
    return setShowPosConfirm(false)
  }
  useEffect(() => {
    PlayerService.getPlayerStructureInfo()
      .then((res) => {
        if (res.status === 200) {
          props.setPlayerStructureDetails(res.data)
        }
      })
      .then(() => {
        GeneralService.getUserGameInfo().then((res) => {
          if (res.status === 200) {
            const isTeamView = res.data?.team_view === 1
            setShowPosBased(isTeamView)
            setLabelText(
              isTeamView
                ? 'Switch to Position Based Selection Mode'
                : 'Switch to Position Free Selection Mode',
            )
            setModalText(
              isTeamView
                ? 'Are you sure you want to set Position Free Selection Mode for the game?'
                : 'Are you sure you want to set Position Based Selection Mode for the game?',
            )
          }
        })
      })
  }, [])
  const [loader, setLoader] = useState(false)
  const validationSchema = Yup.object().shape({
    min_bat: Yup.number()
      .min(1, 'Minimum value of 1 is required')
      .required('Min Batsman is required'),
    max_bat: Yup.number()
      .max(5, 'Maximum cannot be greater than 5')
      .required('Max Batsman is required'),

    min_bowl: Yup.number()
      .min(1, 'Minimum value of 1 is required')
      .required('Min Bowler is required'),
    max_bowl: Yup.number()
      .max(5, 'Maximum cannot be greater than 5')
      .required('Max Bowler is required'),
    min_ar: Yup.number()
      .min(1, 'Minimum value of 1 is required')
      .required('Min All-Rounder is required'),
    max_ar: Yup.number()
      .max(5, 'Maximum cannot be greater than 5')
      .required('Max All-Rounder is required'),
    min_wk: Yup.number()
      .min(1, 'Minimum value of 1 is required')
      .required('Min Wicket Keeper is required'),
    max_wk: Yup.number()
      .max(5, 'Maximum cannot be greater than 5')
      .required('Max Wicket Keeper is required'),
  })
  const formik = useFormik({
    initialValues: {
      min_bat: props.playerStructuredetails?.min_bats,
      max_bat: props.playerStructuredetails?.max_bats,
      min_bowl: props.playerStructuredetails?.min_bowls,
      max_bowl: props.playerStructuredetails?.max_bowls,
      min_ar: props.playerStructuredetails?.min_ar,
      max_ar: props.playerStructuredetails?.max_ar,
      min_wk: props.playerStructuredetails?.min_wks,
      max_wk: props.playerStructuredetails?.max_wks,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data) => {
      setLoader(true)
      PlayerService.savePlayerStructure(data)
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
            setLoader(false)
          }
        })
        .then(() => {
          data.addOnType = 'team_view'
          data.status = showPosBased
          GeneralService.changeUserGameAddOnStatus(data)
        })
    },
  })

  const handleChangeStatus = (event) => {
    setModalText(
      event.target.checked
        ? 'Are you sure you want to set Position Free Selection Mode for the game?'
        : 'Are you sure you want to set Position Based Selection Mode for the game?',
    )
    setShowPosConfirm(true)
    setShowPosBased(event.target.checked)
  }
  const savePosFree = () => {
    const data = {}
    data.addOnType = 'team_view'

    data.status = showPosBased ? true : false

    GeneralService.changeUserGameAddOnStatus(data).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
      }
    })
  }

  return (
    <>
      <CCol xs={12}>
        <CForm className="row g-3" onSubmit={formik.handleSubmit}>
          <strong>
            <CFormSwitch
              size="lg"
              label={labelText}
              id="formSwitchCheckDefaultLg"
              checked={showPosBased ? true : false}
              onChange={handleChangeStatus}
              disabled={props.isTeamExists}
            />
          </strong>
          {!showPosBased && (
            <>
              <h6>Mode: Position Based Selection (Default)</h6>
              <CCol xs={12}>
                <ul>
                  <li>
                    In this mode, your game requires members to pick{' '}
                    <strong> {props.gameData?.team_size} players</strong> based on the set player
                    limits for each position .
                  </li>
                  <li>You can set your own player selection limits for each position here.</li>
                  <li>
                    If no change is required, you can leave the default limits as currently set
                    below.
                  </li>
                </ul>
              </CCol>
            </>
          )}
          {showPosBased == 1 && (
            <>
              <h6>Mode: Position Free Selection Mode</h6>
              <CCol xs={12}>
                <ul>
                  <li>
                    In this mode, your game does not require members to pick players based on the
                    set player limits for each position.
                  </li>
                  <li>
                    There is no requirement for you to set player selection limits for each
                    position.
                  </li>
                  <li>
                    Members can select unlimited players from a certain position to pick their
                    fantasy team.
                  </li>
                  <li>This mode makes your game independent of position based restrictions.</li>
                </ul>
              </CCol>
            </>
          )}

          {!showPosBased && (
            <>
              <CInputGroup className="mb-3 fw-bold">
                <CInputGroupText className="fw-bold w-23" style={{ width: '170px' }}>
                  Min Bat
                </CInputGroupText>
                <CFormInput
                  placeholder="Min Bat"
                  disabled={props.isTeamExists}
                  className={`form-control ${
                    formik.errors.min_bat && formik.touched.min_bat ? 'is-invalid' : ''
                  }`}
                  value={formik.values.min_bat}
                  onChange={formik.handleChange}
                  aria-label="min_bat"
                  id="min_bat"
                />

                <CInputGroupText className="fw-bold">-</CInputGroupText>
                <CFormInput
                  placeholder="Max Bat"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.max_bat && formik.touched.max_bat ? ' is-invalid' : '')
                  }
                  value={formik.values.max_bat}
                  onChange={formik.handleChange}
                  aria-label="max_bat"
                  id="max_bat"
                />
                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Max Bat
                </CInputGroupText>
                <CFormFeedback invalid>{formik.errors.min_bat}</CFormFeedback>
                <CFormFeedback invalid>{formik.errors.max_bat}</CFormFeedback>
              </CInputGroup>

              <CInputGroup className="mb-3 fw-bold">
                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Min Bowl
                </CInputGroupText>
                <CFormInput
                  placeholder="Min Bowler"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.min_bowl && formik.touched.min_bowl ? ' is-invalid' : '')
                  }
                  value={formik.values.min_bowl}
                  onChange={formik.handleChange}
                  aria-label="min_bowl"
                  id="min_bowl"
                />

                <CInputGroupText className="fw-bold">-</CInputGroupText>
                <CFormInput
                  placeholder="Max Bowler"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.max_bowl && formik.touched.max_bowl ? ' is-invalid' : '')
                  }
                  value={formik.values.max_bowl}
                  onChange={formik.handleChange}
                  aria-label="max_bowl"
                  id="max_bowl"
                />

                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Max Bowl
                </CInputGroupText>
                {formik.errors.min_bowl && formik.touched.min_bowl && (
                  <CFormFeedback invalid>{formik.errors.min_bowl}</CFormFeedback>
                )}
                {formik.errors.max_bowl && formik.touched.max_bowl && (
                  <CFormFeedback invalid>{formik.errors.max_bowl}</CFormFeedback>
                )}
              </CInputGroup>

              <CInputGroup className="mb-3 fw-bold">
                <CInputGroupText className="fw-bold w-22" style={{ width: '170px' }}>
                  Min AR
                </CInputGroupText>
                <CFormInput
                  placeholder="Min All-Rounder"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.min_ar && formik.touched.min_ar ? ' is-invalid' : '')
                  }
                  value={formik.values.min_ar}
                  onChange={formik.handleChange}
                  aria-label="min_ar"
                  id="min_ar"
                />

                <CInputGroupText className="fw-bold">-</CInputGroupText>
                <CFormInput
                  placeholder="Max All-Rounder"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.max_ar && formik.touched.max_ar ? ' is-invalid' : '')
                  }
                  value={formik.values.max_ar}
                  onChange={formik.handleChange}
                  aria-label="max_ar"
                  id="max_ar"
                />

                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Max AR
                </CInputGroupText>
                {formik.errors.min_ar && formik.touched.min_ar && (
                  <CFormFeedback invalid>{formik.errors.min_ar}</CFormFeedback>
                )}
                {formik.errors.max_ar && formik.touched.max_ar && (
                  <CFormFeedback invalid>{formik.errors.max_ar}</CFormFeedback>
                )}
              </CInputGroup>

              <CInputGroup className="mb-3 fw-bold">
                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Min WK
                </CInputGroupText>
                <CFormInput
                  placeholder="Min Wicket Keeper"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.min_wk && formik.touched.min_wk ? ' is-invalid' : '')
                  }
                  value={formik.values.min_wk}
                  onChange={formik.handleChange}
                  aria-label="min_wk"
                  id="min_wk"
                />

                <CInputGroupText className="fw-bold">-</CInputGroupText>
                <CFormInput
                  placeholder="Max Wicket Keeper"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.max_wk && formik.touched.max_wk ? ' is-invalid' : '')
                  }
                  value={formik.values.max_wk}
                  onChange={formik.handleChange}
                  aria-label="max_wk"
                  id="max_wk"
                />

                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Max WK
                </CInputGroupText>
                {formik.errors.min_wk && formik.touched.min_wk && (
                  <CFormFeedback invalid>{formik.errors.min_wk}</CFormFeedback>
                )}
                {formik.errors.max_wk && formik.touched.max_wk && (
                  <CFormFeedback invalid>{formik.errors.max_wk}</CFormFeedback>
                )}
              </CInputGroup>
              <CCol md={6}>
                <CLoadingButton
                  type="submit"
                  color="success"
                  variant="outline"
                  loading={loader}
                  disabled={props.isTeamExists}
                  id="submit"
                >
                  Submit
                </CLoadingButton>
              </CCol>
            </>
          )}
        </CForm>
      </CCol>
      <Bootbox
        show={showPosConfirm}
        type={'confirm'}
        message={modalText}
        onSuccess={handlePosConfirm}
        onCancel={handlePosCancel}
        onClose={handlePosCancel}
      />
    </>
  )
}

export default PlayerStructure
